import * as React from "react";
import { Toggle } from "@fluentui/react/lib/Toggle";
import { InputProps } from "../../interfaces/props/InputProps";
import { logger } from "../../../../utilities/logger";
import { LanguageContext } from "../../../../utilities/LocalizationModule";
import { SharePointMetadataBooleans } from "../../config/sharepointConstants";

export const YesNo: React.FunctionComponent<InputProps> = ({
  displayName,
  inputValidator,
  inputValue,
  updateInputValidationStatus
}: InputProps) => {
  const languageStrings = React.useContext(LanguageContext);
  const [isChecked, setChecked] = React.useState(true);

  React.useEffect(() => {
    setChecked(inputValue?.value == "1" ? true : false)
  }, [inputValue?.value])

  const isFirstRun = React.useRef(true);
  React.useEffect(() => {
    try {
      if (isFirstRun.current) {
        isFirstRun.current = false;
        return;
      }
      updateInputValidationStatus(inputValidator.validate(inputValue?.value));
    } catch (e) {
      logger(e, "YesNo.tsx (useEffect 2)")
    }
  }, [inputValue?.updatedFromDataSourceToggle]);

  const handleNumberChange = (event: any, checked: boolean) => {
    let value = checked ? "1" : "0";
    updateInputValidationStatus(inputValidator.validate(value));
    setChecked(checked);
  };

  return (
    <>
      <Toggle
        disabled={inputValue?.xml?.ReadOnly === SharePointMetadataBooleans.true}
        label={displayName}
        checked={isChecked}
        onText={languageStrings.Yes}
        offText={languageStrings.No}
        onChange={handleNumberChange}
        role="checkbox"
      />
    </>
  );
};

export default YesNo;
